import React, { FunctionComponent, useState, useEffect } from "react";
import Modal from "react-modal";
import styles from "./AddResourceModal.module.css";
import { IoIosClose } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import {themeColors} from "../../theme";
import { motion,AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import {createResourceMongo} from "../../../Services/resources";
import InputWithAutoComplete from "../../DropDown/InputWithAutoComplete";
import { showSnackbarAction } from "../../../Redux/actions";

type props = {
  open: boolean;
  close: () => void;
  heading: string;
  title: string;
  theme:any;
  type:string;
  subType:string;
  dispatcher:any,
  setLoad: (data: boolean) => void,
  user:any,
  authToken:any,
  constants: any,
  setdata?:(data:any)=>void,
  reload?:any
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const AddResources: FunctionComponent<props> = ({
  open,
  close,
  heading,
  title,
  theme,
  type,
  subType,
  dispatcher,
  setLoad,
  user,
  authToken,
  constants,
  setdata,
  reload
}) => {
  const [value, setValue] = useState("");
  const [leadSources, setLeadSources] = useState();

  const constant = async () => {
    const leadSources = constants.leadSources;
    setLeadSources(leadSources);
  };

  useEffect(() => {
    if (constants) {
      constant();
    }
  }, []);

  const onSubmit = () => {
    try {
      if(value.trim() === ""|| value===undefined || value===null){
        dispatcher(
              showSnackbarAction("Please enter value", "error")
            );
            return
      }
      const obj=[{
           [subType]:value?.trim(),
           modified_by:user.uid
      }]
      if (setdata) {
        setdata(value?.trim());
      }
console.log("value",value)
      createResourceMongo(
        user.organization_id,
        type,
        obj,
        dispatcher,
        setLoad,
        close,
        authToken,
        reload
      )
    } catch (error) {
      
    }
  };

  const containerStyles ={ backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark} 
  return (
    // <Modal
    //   isOpen={open}
    //   className={styles.parent}
    //   overlayClassName={styles.overlay}
    //   onRequestClose={close}
    //   shouldCloseOnOverlayClick={true}
    //   shouldCloseOnEsc={true}
    //   style={customStyles}
    //   // closeTimeoutMS={500}
    //   closeTimeoutMS={2000}
    // >
    //   <div className={styles.headingContainer}>
    //   <h5 
    //   // className={styles.heading}
    //   >{heading}</h5>
    //   <div className={styles.icon} onClick={close}>
    //     <IoIosClose size={35} color={"#808080"} />
    //   </div>
    //   </div>
    //   <div className={styles.nameBox}>
    //     {/* <span className={styles.name}>{title}</span> */}
    //     <h6>{title}:</h6>
    //     <input
    //       className={styles.input}
    //       placeholder={title}
    //       onChange={(event) => setValue(event.target.value)}
    //     />
    //   </div>
    //   <div className={styles.button}>
    //     <button className={styles.cancel} onClick={close}>
    //       Cancel
    //     </button>
    //     <button className={styles.change} onClick={() => onSave(value)}>
    //       Save
    //     </button>
    //   </div>
    // </Modal>

     <Backdrop>
      <motion.div
        key="modal"
        className="card p-4 shadow rounded"
        style={{position: "absolute",
        ...containerStyles}}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
      <div className={styles.headingContainer}>
      <h5 
      // className={styles.heading}
      >{heading}</h5>
      {/* <div className={styles.icon} onClick={close}>
        <IoIosClose size={35} color={"#808080"} />
      </div> */}
      </div>
      <div className={styles.nameBox}>
        {/* <span className={styles.name}>{title}</span> */}
        <h6>{title}:</h6>
        {
          heading !== "Lead Source" &&
          <input
          // className={styles.input}
          className="form-control"
          style={{  flex: 1,fontSize:"14px"}}
          placeholder={""}
          onChange={(event) => setValue(event.target.value)}
        />
        }
        {heading == "Lead Source" && <InputWithAutoComplete value={value} options={leadSources} setValue={(val:any)=>{setValue(val)}} />}
      </div>
      <div className={styles.button}>
      <button className={styles.change} onClick={()=>onSubmit()}>
          Save
        </button>
        <button className={styles.cancel} onClick={close}>
          Cancel
        </button>
      </div>
      </motion.div>
     </Backdrop>
  );
};



const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    contacts: state.contacts,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    constants:state.constants.data,
  };
};

export default connect(mapStateToProps)(AddResources);

